import React, { useState, useEffect } from 'react';
import { 
  Box, 
  Typography, 
  Button, 
  Paper, 
  Card, 
  CardContent, 
  CardActions,
  TextField,
  Stack,
  Divider
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

const MockPayment = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [amount, setAmount] = useState(0);
  const [sessionId, setSessionId] = useState('');

  // Parse amount from location state or query params
  useEffect(() => {
    // Generate a unique session ID for this mock payment
    setSessionId(`mock_sess_${Math.random().toString(36).substring(2, 15)}`);
    
    // Try to get the amount from state
    const amountFromState = location.state?.amount;
    
    if (amountFromState) {
      setAmount(amountFromState);
    } else {
      // Try to parse from URL search params
      const searchParams = new URLSearchParams(location.search);
      const amountParam = searchParams.get('amount');
      if (amountParam) {
        setAmount(parseFloat(amountParam));
      } else {
        // Default amount
        setAmount(10);
      }
    }
  }, [location]);

  const handleSuccess = () => {
    // Store amount in sessionStorage so we can retrieve it in the success page
    sessionStorage.setItem('mockPaymentAmount', amount.toString());
    
    // Simulate a successful payment
    navigate(`/billing/success?session_id=${sessionId}&amount=${amount}`);
  };

  const handleCancel = () => {
    // Simulate a cancelled payment
    navigate('/billing/cancel');
  };

  return (
    <Box sx={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center',
      minHeight: '100vh',
      p: 3,
      backgroundColor: '#f8f9fa'
    }}>
      <Paper elevation={3} sx={{ 
        width: '100%', 
        maxWidth: 500, 
        p: 4, 
        borderRadius: 2,
        mt: 8
      }}>
        <Typography variant="h4" align="center" gutterBottom sx={{ mb: 3 }}>
          Mock Payment Checkout
        </Typography>
        
        <Divider sx={{ mb: 3 }} />
        
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
          <CreditCardIcon color="primary" sx={{ fontSize: 60 }} />
        </Box>
        
        <Card variant="outlined" sx={{ mb: 3 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Payment Details
            </Typography>
            <Typography>
              <strong>Amount:</strong> ${amount.toFixed(2)}
            </Typography>
            <Typography>
              <strong>Session ID:</strong> {sessionId}
            </Typography>
            <Typography color="text.secondary" sx={{ mt: 2 }}>
              This is a mock payment page for testing. No actual payment will be processed.
            </Typography>
          </CardContent>
        </Card>
        
        <TextField
          label="Test Card Number"
          value="4242 4242 4242 4242"
          fullWidth
          disabled
          sx={{ mb: 2 }}
          helperText="This is a test card number (not editable)"
        />
        
        <Stack direction="row" spacing={2} sx={{ mt: 3 }}>
          <Button 
            variant="outlined" 
            color="error" 
            fullWidth 
            onClick={handleCancel}
            startIcon={<CancelIcon />}
          >
            Cancel Payment
          </Button>
          <Button 
            variant="contained" 
            color="success" 
            fullWidth 
            onClick={handleSuccess}
            startIcon={<CheckCircleIcon />}
          >
            Complete Payment
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
};

export default MockPayment; 